export const getTourRequest = (tourId, tourType) => {
    return new Promise((resolve, reject) => {
        const requestInfo = process.env.NODE_ENV === 'development'
            ? {
                method: 'get',
                mode: 'cors',
                credentials: 'include'
            }
            : {
                credentials: 'include',
                method: 'get'
            };
        fetch(`${getDomainName()}/api/tour/${tourId}/${tourType}`, requestInfo).then(response => {
            if (response.status === 401 || response.status === 400) {
                response.json().then(res => { reject(res); });
            } else {
                response.json().then(
                    result => { resolve(result); },
                    err => { reject(err); }
                );
            }
        })
        .catch(reject);
    });
}

export const getGalleryRequest = (tourId, tourType) => {
    return new Promise((resolve, reject) => {
        const requestInfo = process.env.NODE_ENV === 'development'
            ? {
                method: 'get',
                mode: 'cors',
                credentials: 'include'
            }
            : {
                credentials: 'include',
                method: 'get'
            };
        fetch(`${getDomainName()}/api/tour/gallery/${tourId}/${tourType}`, requestInfo).then(response => {
            if (response.status === 401 || response.status === 400) {
                response.json().then(res => { reject(res); });
            } else {
                response.json().then(
                    result => { resolve(result); },
                    err => { reject(err); }
                );
            }
        })
        .catch(reject);
    });
}

export const getOtherListingsRequest = (tourId, tourType) => {
    return new Promise((resolve, reject) => {
        const requestInfo = process.env.NODE_ENV === 'development'
            ? {
                method: 'get',
                mode: 'cors',
                credentials: 'include'
            }
            : {
                credentials: 'include',
                method: 'get'
            };
        fetch(`${getDomainName()}/api/tour/order-featured-listings/${tourId}/${tourType}/5/0`, requestInfo).then(response => {
            if (response.status === 401 || response.status === 400) {
                response.json().then(res => { reject(res); });
            } else {
                response.json().then(
                    result => { resolve(result); },
                    err => { reject(err); }
                );
            }
        })
        .catch(reject);
    });
}

export const getFeaturedRequest = (agentId, listingPerPage, startFrom) => {
    return new Promise((resolve, reject) => {
        const requestInfo = process.env.NODE_ENV === 'development'
            ? {
                method: 'get',
                mode: 'cors',
                credentials: 'include'
            }
            : {
                credentials: 'include',
                method: 'get'
            };
        fetch(`${getDomainName()}/api/tour/agent-featured-listings/${agentId}/${listingPerPage}/${startFrom}`, requestInfo).then(response => {
            if (response.status === 401 || response.status === 400) {
                response.json().then(res => { reject(res); });
            } else {
                response.json().then(
                    result => { resolve(result); },
                    err => { reject(err); }
                );
            }
        })
        .catch(reject);
    });
}

export const geocoderRequest = address => {
        return new Promise( (resolve, reject) => {
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({'address': address}, (results, status) => {
            if (status != window.google.maps.GeocoderStatus.OK) {
                reject({
                    errorMessage: 'This address wasn\'t found for the following reason: ' + status,
                    address: address
                });
            } else {
                resolve(results[0].geometry.location);
            }
        });
    });
}

export const sendEmailReq = (params, tourId) => {
    return new Promise((resolve, reject) => {
        const requestInfo = process.env.NODE_ENV === 'development'
            ? {
                method: 'post',
                mode: 'cors',
                credentials: 'include',
                body: JSON.stringify(params)
            }
            : {
                credentials: 'include',
                method: 'post',
                body: JSON.stringify(params)
            };
        fetch(`${getDomainName()}/api/send/${tourId}`, requestInfo).then(response => {
            if (response.status === 401 || response.status === 400) {
                response.json().then(res => { reject(res); });
            } else {
                response.json().then(
                    result => { resolve(result); },
                    err => { reject(err); }
                );
            }
        })
        .catch(reject);
    });
};

export const getBackgroundImageReq = (tourId) => {
    return new Promise((resolve, reject) => {
        const requestInfo = process.env.NODE_ENV === 'development'
            ? {
                method: 'get',
                mode: 'cors',
                credentials: 'include'
            }
            : {
                credentials: 'include',
                method: 'get'
            };
        fetch(`${getDomainName()}/api/tour/front-photo/${tourId}`, requestInfo).then(response => {
            if (response.status === 401 || response.status === 400) {
                response.json().then(res => { reject(res); });
            } else {
                response.json().then(
                    result => { resolve(result); },
                    err => { reject(err); }
                );
            }
        })
        .catch(reject);
    });
}

const getDomainName = () => {
    return domainName;
}
